var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabbed-content" }, [
    _vm.hasContent
      ? _c("div", { staticClass: "tabbed-content__tabs" }, [
          _c("ul", { staticClass: "tabs" }, [
            _vm.$slots.overview
              ? _c("li", [
                  _c(
                    "a",
                    {
                      class: { selected: _vm.selectedTabSlug === "overview" },
                      attrs: { href: _vm.makeUrlForTab("overview") },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.didSelectTab("overview")
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("Overview")]),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.chevronRight) }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$slots.members
              ? _c("li", [
                  _c(
                    "a",
                    {
                      class: { selected: _vm.selectedTabSlug === "members" },
                      attrs: { href: _vm.makeUrlForTab("members") },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.didSelectTab("members")
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("Group Members")]),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.chevronRight) }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$slots.themes
              ? _c("li", [
                  _c(
                    "a",
                    {
                      class: { selected: _vm.selectedTabSlug === "themes" },
                      attrs: { href: _vm.makeUrlForTab("themes") },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.didSelectTab("themes")
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("Research Themes")]),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.chevronRight) }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$slots.research
              ? _c("li", [
                  _c(
                    "a",
                    {
                      class: { selected: _vm.selectedTabSlug === "research" },
                      attrs: { href: _vm.makeUrlForTab("research") },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.didSelectTab("research")
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("Research Interests")]),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.chevronRight) }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$slots.bio
              ? _c("li", [
                  _c(
                    "a",
                    {
                      class: { selected: _vm.selectedTabSlug === "bio" },
                      attrs: { href: _vm.makeUrlForTab("bio") },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.didSelectTab("bio")
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("Biography")]),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.chevronRight) }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$slots.publications
              ? _c("li", [
                  _c(
                    "a",
                    {
                      class: {
                        selected: _vm.selectedTabSlug === "publications"
                      },
                      attrs: { href: _vm.makeUrlForTab("publications") },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.didSelectTab("publications")
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("Selected Publications")]),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.chevronRight) }
                      })
                    ]
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$slots.contact
      ? _c(
          "div",
          { staticClass: "tabbed-content__contact" },
          [_vm._t("contact")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasContent
      ? _c(
          "div",
          { staticClass: "tabbed-content__tab-content" },
          [
            _c(
              "transition",
              { attrs: { name: "fade-quick", mode: "out-in" } },
              [
                _vm.$slots.overview && _vm.selectedTabSlug === "overview"
                  ? _c(
                      "div",
                      {
                        key: "overview",
                        staticClass:
                          "tabbed-content__tab-content__overview rich-text"
                      },
                      [_vm._t("overview")],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$slots.members && _vm.selectedTabSlug === "members"
                  ? _c(
                      "div",
                      {
                        key: "members",
                        staticClass: "tabbed-content__tab-content__members"
                      },
                      [_vm._t("members")],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$slots.c && _vm.selectedTabSlug === "themes"
                  ? _c(
                      "div",
                      {
                        key: "themes",
                        staticClass:
                          "tabbed-content__tab-content__researh-themes rich-text"
                      },
                      [_vm._t("themes")],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$slots.research && _vm.selectedTabSlug === "research"
                  ? _c(
                      "div",
                      {
                        key: "research",
                        staticClass:
                          "tabbed-content__tab-content__research-interests rich-text"
                      },
                      [_vm._t("research")],
                      2
                    )
                  : _vm.$slots.bio && _vm.selectedTabSlug === "bio"
                  ? _c(
                      "div",
                      {
                        key: "bio",
                        staticClass:
                          "tabbed-content__tab-content__bio rich-text"
                      },
                      [_vm._t("bio")],
                      2
                    )
                  : _vm.$slots.publications &&
                    _vm.selectedTabSlug === "publications"
                  ? _c(
                      "div",
                      {
                        key: "publications",
                        staticClass: "tabbed-content__tab-content__publications"
                      },
                      [_vm._t("publications")],
                      2
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "tabbed-content__footer" }, [_vm._t("footer")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib?{}!./scripts/vue/TabbedContent.vue?vue&type=template&id=16151d89&
// module id = 116
// module chunks = 0